export default __webpack_public_path__ + "static/media/4-Cloudxier-PTSTP.f2eed816.jpg";